import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { Eyebrow, PrimaryCTA } from "@/components/ui-bits";
import PostContent from "@/components/PostContent";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

function formatDate(iso) {
  try { return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" }); }
  catch { return ""; }
}

export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/posts/${slug}`)
      .then(({ data }) => setPost(data))
      .catch(() => navigate("/blog"))
      .finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [slug, navigate]);

  if (loading) return <Layout><div className="max-w-3xl mx-auto px-6 py-32 text-ink-soft" data-testid="post-loading">Loading…</div></Layout>;
  if (!post) return null;

  return (
    <Layout>
      <article data-testid="blog-post">
        <section className="border-b border-hairline">
          <div className="max-w-3xl mx-auto px-6 lg:px-8 pt-16 pb-12">
            <Link to="/blog" className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-ink-soft hover:text-brass mb-10" data-testid="back-to-blog">
              <ArrowLeft className="w-3 h-3" strokeWidth={2} /> Insights
            </Link>
            <Eyebrow>{post.category}</Eyebrow>
            <h1 className="display-1 text-ink mt-5 leading-[1.1]">{post.title}</h1>
            <p className="mt-8 text-sm text-ink-soft tracking-wide">By {post.author}</p>
          </div>
        </section>

        <section className="max-w-3xl mx-auto px-6 lg:px-8 py-16 prose-law">
          <PostContent content={post.content} />
        </section>

        <section className="border-t border-hairline bg-ivory-alt">
          <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16 text-center">
            <Eyebrow>Inquiries</Eyebrow>
            <h3 className="font-serif text-3xl text-ink leading-tight mt-4 mb-8">
              To discuss a related matter, contact the firm.
            </h3>
            <div className="flex justify-center">
              <PrimaryCTA to="/contact" testId="post-cta">Contact the Firm</PrimaryCTA>
            </div>
          </div>
        </section>
      </article>
    </Layout>
  );
}
